// ===========================================================
// ERP CORE - Global Configuration (FIXED VERSION v2.3)
// ===========================================================

window.CURRENCY_HISTORY = {};

const GLOBAL_CONFIG = {
  DROPSHIPPER_TAG: 'fishondropshipper',
  WHOLESALE_TAG: 'fishonwholesale',
  RETAIL_TAG: 'fishonretail',
  
  BASE_CURRENCY: 'AED',
  SHOP_CURRENCY: window.Shopify?.currency?.active || 'AED',

  EXCHANGE_RATES: {
    'AED': 1.0,
    'USD': 3.676,
    'EUR': 3.985,
    'GBP': 4.67,
    'SAR': 0.979,
    'QAR': 1.006,
    'OMR': 9.54,
    'BHD': 9.74
  }
};

// ⚠️ FIXED: Removed space after latest/
async function fetchExchangeRates() {
  if (window.EXCHANGE_RATES_LOADED) return;
  window.EXCHANGE_RATES_LOADED = true;
  
  try {
    const res = await fetch(`https://api.exchangerate-api.com/v4/latest/${GLOBAL_CONFIG.BASE_CURRENCY}`);
    if (!res.ok) throw new Error('Rate API failed');
    const data = await res.json();
    window.EXCHANGE_RATES = data.rates;
    console.log('✅ Exchange rates loaded from API');
  } catch (e) {
    console.warn('⚠️ Rate API failed, using hardcoded rates:', e.message);
    window.EXCHANGE_RATES = GLOBAL_CONFIG.EXCHANGE_RATES;
  }
}

function convertToStoreCurrency(amount, fromCurrency, referenceId = 'last_action') {
    const numericAmount = parseFloat(amount) || 0;
    window.CURRENCY_HISTORY[referenceId] = {
        originalAmount: numericAmount,
        originalCurrency: fromCurrency || 'AED',
        timestamp: new Date()
    };

    const storeCurrency = GLOBAL_CONFIG.BASE_CURRENCY;
    if (!fromCurrency || fromCurrency === storeCurrency) return numericAmount;

    const RATES = window.EXCHANGE_RATES || GLOBAL_CONFIG.EXCHANGE_RATES;
    const rate = RATES[fromCurrency];
    if (!rate) {
        console.warn(`No rate for ${fromCurrency}`);
        return numericAmount;
    }

    const result = numericAmount * rate;
    window.CURRENCY_HISTORY[referenceId].convertedAmount = result;
    return result;
}

function formatPrice(amount, currency = null) {
  const symbol = currency || GLOBAL_CONFIG.BASE_CURRENCY;
  return `${symbol} ${parseFloat(amount).toFixed(2)}`;
}

function getOrderCurrency(order) {
  const currency = order.currency || 
                   order.presentment_currency || 
                   order.total_price_set?.presentment_money?.currency_code ||
                   GLOBAL_CONFIG.SHOP_CURRENCY || 
                   'AED';
  return currency;
}

// 0. Canvas polyfill
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {
    shop: "fishion-llc.myshopify.com",
    currency: { active: "AED" }
  };
}
window.__st = window.__st || { cid: undefined };
(() => {
  const original = HTMLCanvasElement.prototype.getContext;
  HTMLCanvasElement.prototype.getContext = function (type, att) {
    if (type === '2d') {
      att = att || {};
      att.willReadFrequently = true;
    }
    return original.call(this, type, att);
  };
})();

// 1. CONFIG
const SYSTEM = {
  BRIDGE: "https://script.google.com/macros/s/AKfycbz2JQkVDvvcA9fpr7fGIhev1a7RLgLReQo9RG2A2gz_DI04FOc1ZD-5rLm_DMgFDYM/exec",
  AUTH: "OceanMania_Secure_998877"
};

const NO_IMAGE = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' style='background:%23ccc'%3E%3Ctext x='50%25' y='50%25' dy='.3em' text-anchor='middle' font-family='Arial' font-size='10'%3EWG%3C/text%3E%3C/svg%3E";

const PAGE_SIZE = 10;
const USER_ROLE = window.USER_ROLE || "Admin";

// Global State
let MASTER_DB = { products:[], orders:[], customers:[], collections:[], mapping:[], location:null, inventoryItems:[] };
let UI_DATA = { inventory:[], orders:[], customers:[] };
let CURRENT_PAGE = { inventory:1, orders:1, customers:1 };

// Connection status
window.ERP_CONNECTION_STATUS = {
  lastError: null,
  isConnected: false,
  retryCount: 0
};

// 2. PAGINATION
const paginate = (items, page, module) => {
  if (!items || !items.length) return [];
  const start = (page - 1) * PAGE_SIZE;
  const slice = items.slice(start, start + PAGE_SIZE);
  renderPaginationUI(module, items.length, page);
  return slice;
};

window.renderPaginationUI = (mod, total, cur) => {
  const holder = document.getElementById(`${mod}-pagination-holder`);
  if (!holder) return;
  const pages = Math.ceil(total / PAGE_SIZE) || 1;
  holder.innerHTML = `
    <div style="display:flex;justify-content:center;align-items:center;gap:20px;padding:15px">
      <button onclick="changeModulePage('${mod}',${cur - 1})"
              ${cur<=1?'disabled style="opacity:.5"':''} class="btn-export">Prev</button>
      <span style="font-weight:bold">Page ${cur} of ${pages}</span>
      <button onclick="changeModulePage('${mod}',${cur + 1})"
              ${cur>=pages?'disabled style="opacity:.5"':''} class="btn-export">Next</button>
    </div>`;
};

window.changeModulePage = (mod, p) => {
  CURRENT_PAGE[mod] = p;
  if (mod === 'inventory' && typeof renderInventoryUI === 'function') renderInventoryUI();
  if (mod === 'orders' && typeof renderOrdersUI === 'function') renderOrdersUI();
  if (mod === 'customers' && typeof renderCustomersUI === 'function') renderCustomersUI();
};

// 3. QUERY SHOPIFY (via GAS Bridge)
async function queryShopify(endpoint, method='GET', payload=null, fetch_all=false){
  try {
    if (!SYSTEM.BRIDGE) {
      throw new Error('Bridge URL not configured');
    }

    console.log(`🌐 API Call: ${method} ${endpoint}`);
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);

    const res = await fetch(SYSTEM.BRIDGE, {
      method:'POST',
      mode:'cors',
      headers:{'Content-Type':'text/plain'},
      signal: controller.signal,
      body:JSON.stringify({
        auth_key:SYSTEM.AUTH, 
        endpoint, 
        method, 
        data:payload, 
        fetch_all
      })
    });

    clearTimeout(timeoutId);

    if (!res.ok) {
      const errorText = await res.text();
      if (res.status === 401) {
        window.ERP_CONNECTION_STATUS.lastError = 'Invalid API credentials';
      }
      return { 
        error: true, 
        status: res.status, 
        message: `HTTP ${res.status}`,
        products: [], orders: [], customers: [], collects: [], inventory_items: []
      };
    }

    const text = await res.text();
    
    if (text.trim().startsWith('<!DOCTYPE') || text.trim().startsWith('<html')) {
      return { 
        error: true, message: 'Server error (HTML)', 
        products: [], orders: [], customers: [], collects: [], inventory_items: []
      };
    }

    try {
      const json = JSON.parse(text);
      if (json.error || json.errors) {
        return { 
          error: true, message: json.error || json.errors,
          products: json.products || [], orders: json.orders || [], 
          customers: json.customers || [], collects: json.collects || [],
          inventory_items: json.inventory_items || []
        };
      }
      window.ERP_CONNECTION_STATUS.isConnected = true;
      return json;
    } catch (parseError) {
      return { 
        error: true, message: 'Invalid JSON',
        products: [], orders: [], customers: [], collects: [], inventory_items: []
      };
    }

  } catch(e) {
    if (e.name === 'AbortError') {
      return { error: true, message: 'Timeout', products: [], orders: [], customers: [], collects: [], inventory_items: [] };
    }
    window.ERP_CONNECTION_STATUS.lastError = e.message;
    return { 
      error: true, message: e.message, 
      products: [], orders: [], customers: [], collects: [], inventory_items: []
    };
  }
}

// 4. BOOT SYSTEM - With improved error handling for collects
async function bootSystem(retryAttempt = 0){
  console.log(`🚀 ERP Booting...`); 
  window.toggleLoader(true);
  
  try {
    // Fetch main data first (critical)
    const mainResults = await Promise.allSettled([
      queryShopify('/products.json','GET',null,true),
      queryShopify('/orders.json','GET',null,true),
      queryShopify('/customers.json','GET',null,true),
      queryShopify('/locations.json','GET',null,true),
      queryShopify('/custom_collections.json','GET',null,true)
    ]);

    // Process critical data
    MASTER_DB.products = mainResults[0].value?.products || [];
    MASTER_DB.orders = mainResults[1].value?.orders || [];
    MASTER_DB.customers = mainResults[2].value?.customers || [];
    MASTER_DB.location = mainResults[3].value?.locations?.[0]?.id || null;
    MASTER_DB.collections = mainResults[4].value?.custom_collections || [];

    // Fetch collects separately (non-critical) with better error handling
    try {
      const collectsRes = await queryShopify('/collects.json','GET',null,true);
      if (collectsRes.error) {
        console.warn('⚠️ Collects API failed (non-critical), building mapping from products...');
        MASTER_DB.mapping = buildMappingFromProducts();
      } else {
        MASTER_DB.mapping = collectsRes.collects || [];
      }
    } catch (collectsErr) {
      console.warn('⚠️ Collects fetch failed (non-critical):', collectsErr.message);
      MASTER_DB.mapping = buildMappingFromProducts();
    }

    console.log(`✅ Loaded: ${MASTER_DB.products.length} products, ${MASTER_DB.orders.length} orders, ${MASTER_DB.customers.length} customers`);

    // Update UI
    UI_DATA.inventory = [...MASTER_DB.products];
    UI_DATA.orders = [...MASTER_DB.orders];
    UI_DATA.customers = [...MASTER_DB.customers];

    if (typeof updateStats === 'function') updateStats();
    if (typeof renderInventoryUI === 'function') renderInventoryUI();
    if (typeof renderOrdersUI === 'function') renderOrdersUI();
    if (typeof renderCustomersUI === 'function') renderCustomersUI();

    // Initialize other modules
    if (typeof window.initDropshipperModule === 'function') {
      window.initDropshipperModule();
    }

    // Background inventory fetch (non-critical)
    if (MASTER_DB.products.length > 0) {
      fetchInventoryItems().catch(() => {
        MASTER_DB.inventoryItems = [];
      });
    }

  } catch(err) {
    console.error('❌ Boot Error:', err);
    if (retryAttempt < 2) {
      setTimeout(() => bootSystem(retryAttempt + 1), 5000);
    }
  } finally {
    window.toggleLoader(false);
  }
}

// NEW: Build mapping from products if collects API fails
function buildMappingFromProducts() {
  const mapping = [];
  if (!MASTER_DB.collections.length) return mapping;
  
  MASTER_DB.products.forEach(product => {
    if (product.collection_id) {
      mapping.push({
        id: Date.now() + Math.random(),
        product_id: product.id,
        collection_id: product.collection_id
      });
    }
  });
  
  console.log(`📊 Built ${mapping.length} mappings from product data`);
  return mapping;
}

// Fetch Inventory Items (Batched)
async function fetchInventoryItems() {
  try {
    const inventoryItemIds = [];
    MASTER_DB.products.forEach(p => {
      p.variants?.forEach(v => {
        if (v.inventory_item_id) inventoryItemIds.push(v.inventory_item_id);
      });
    });

    const uniqueIds = [...new Set(inventoryItemIds)];
    if (uniqueIds.length === 0) {
      MASTER_DB.inventoryItems = [];
      return;
    }

    const batchSize = 20;
    MASTER_DB.inventoryItems = [];

    for (let i = 0; i < uniqueIds.length; i += batchSize) {
      const batch = uniqueIds.slice(i, i + batchSize);
      const idsParam = batch.join(',');
      
      if (idsParam.length > 1500) {
        for (const id of batch) {
          try {
            const res = await queryShopify(`/inventory_items.json?ids=${id}`, 'GET', null, false);
            if (res?.inventory_items) MASTER_DB.inventoryItems.push(...res.inventory_items);
            await new Promise(r => setTimeout(r, 100));
          } catch (e) {
            console.warn(`Failed inventory item ${id}`);
          }
        }
      } else {
        const res = await queryShopify(`/inventory_items.json?ids=${idsParam}`, 'GET', null, false);
        if (res?.inventory_items) MASTER_DB.inventoryItems.push(...res.inventory_items);
        if (i + batchSize < uniqueIds.length) await new Promise(r => setTimeout(r, 200));
      }
    }
    
    console.log(`✅ Inventory Items: ${MASTER_DB.inventoryItems.length}`);
  } catch (e) {
    console.error('❌ Inventory Fetch Error:', e);
    MASTER_DB.inventoryItems = [];
  }
}

// Shipping Functions
async function fetchOrderShipping(orderId) {
  try {
    const result = await queryShopify('/get_order_shipping', 'POST', { order_id: orderId });
    if (result.status === 'success') {
      return {
        price: result.shipping_price,
        title: result.shipping_title,
        currency: result.currency
      };
    }
    return { price: 0, title: 'Standard Shipping', currency: 'AED' };
  } catch (err) {
    return { price: 0, title: 'Standard Shipping', currency: 'AED' };
  }
}

// 5. MODULE SWITCHER
window.switchModule = function(moduleName, navId) {
  const adminOnlyModules = ['orders', 'customers', 'balance-sheet', 'dropshipper','vendors'];
  if (USER_ROLE !== 'Admin' && adminOnlyModules.includes(moduleName)) {
    const target = document.getElementById(moduleName + '-target');
    if (target) {
      target.innerHTML = `<div class="empty-state-container"><h3>🚫 Restricted Access</h3><p>Admins only.</p></div>`;
    }
    alert("🚫 Access Denied");
    return;
  }

  document.querySelectorAll('.main-pane').forEach(p => p.classList.remove('active'));
  document.querySelectorAll('.nav-item').forEach(n => n.classList.remove('active'));
  
  const pane = document.getElementById(moduleName + '-pane');
  const nav = document.getElementById(navId);
  const title = document.getElementById('panel-title');
  
  if (pane) pane.classList.add('active');
  if (nav) nav.classList.add('active');
  if (title) title.innerText = moduleName.toUpperCase();

  const exportBtns = document.querySelectorAll('.btn-export');
  exportBtns.forEach(btn => {
    if(btn.classList.contains('excel')) {
      btn.setAttribute('onclick', `exportToExcel('${moduleName.toUpperCase()}')`);
    } else if(btn.classList.contains('pdf')) {
      btn.setAttribute('onclick', `exportToPDF('${moduleName.toUpperCase()}')`);
    }
  });

  switch(moduleName) {
    case 'orders':
      if (typeof renderOrdersUI === 'function') renderOrdersUI();
      break;
    case 'customers':
      if (typeof renderCustomersUI === 'function') renderCustomersUI();
      break;
    case 'inventory':
      if (typeof renderInventoryUI === 'function') renderInventoryUI();
      break;
    case 'stock-aging':
      if (typeof initStockAgingModule === 'function') initStockAgingModule();
      hideExportButtons(['att-export-btn', 'inv-export-btn', 'pdf-export-btn']);
      break;
    case 'vendors':
      if (typeof initVendorModule === 'function') initVendorModule();
      hideExportButtons(['att-export-btn', 'inv-export-btn', 'pdf-export-btn']);
      showExportButton('vendor-export-btn');
      break;
    case 'dropshipper':
      if (typeof initDropshipperModule === 'function') initDropshipperModule();
      hideExportButtons(['att-export-btn', 'inv-export-btn', 'pdf-export-btn']);
      break;
    case 'balance-sheet':
      if (typeof initBalanceSheetModule === 'function') initBalanceSheetModule();
      hideExportButtons(['att-export-btn', 'inv-export-btn', 'pdf-export-btn']);
      break;
  }
};

function hideExportButtons(ids) {
  ids.forEach(id => {
    const btn = document.getElementById(id);
    if (btn) btn.style.display = 'none';
  });
}

function showExportButton(id) {
  const btn = document.getElementById(id);
  if (btn) btn.style.display = 'inline-block';
}

// 6. STATS UPDATE
function updateStats() {
  const safeSet = (id, value) => {
    const el = document.getElementById(id);
    if (el) el.innerText = value;
  };

  const now = new Date();
  const fortyEightHoursAgo = new Date(now.getTime() - (48 * 60 * 60 * 1000));

  const totalProds = MASTER_DB.products.length;
  let totalVars = 0, totalStock = 0, lowStockCount = 0, outOfStockCount = 0;
  
  MASTER_DB.products.forEach(p => {
    totalVars += p.variants?.length || 0;
    p.variants?.forEach(v => {
      const qty = parseInt(v.inventory_quantity) || 0;
      totalStock += qty;
      if (qty <= 0) outOfStockCount++;
      else if (qty <= 5) lowStockCount++;
    });
  });

  const allO = MASTER_DB.orders || [];
  const activeOrders = allO.filter(o => !o.cancelled_at && o.financial_status !== 'refunded' && !(o.closed_at && o.fulfillment_status === 'fulfilled'));

  const paidFulfilled48h = activeOrders.filter(o => {
    const orderDate = new Date(o.updated_at);
    return o.financial_status === 'paid' && o.fulfillment_status === 'fulfilled' && orderDate >= fortyEightHoursAgo;
  }).length;

  const codFulfilled48h = activeOrders.filter(o => {
    const orderDate = new Date(o.updated_at);
    return (o.financial_status === 'pending' || o.financial_status === 'authorized') && 
           o.fulfillment_status === 'fulfilled' && 
           orderDate >= fortyEightHoursAgo;
  }).length;

  const totalUnfulfilled = activeOrders.filter(o => !o.fulfillment_status || o.fulfillment_status === 'restocked').length;

  safeSet('stat-products', totalProds);
  safeSet('stat-variants', totalVars);
  safeSet('stat-stock-total', totalStock);
  safeSet('stat-stock-low', lowStockCount);
  safeSet('stat-stock-out', outOfStockCount);
  safeSet('stat-orders-paid', paidFulfilled48h);
  safeSet('stat-orders-cod', codFulfilled48h);
  safeSet('stat-orders-unful', totalUnfulfilled);
}

// 7. HELPERS
window.toggleLoader = show => {
  const l = document.getElementById('global-loader');
  if(l) l.style.display = show ? 'flex' : 'none';
};

window.handleLogout = () => confirm("Logout?") ? window.location.href="/account/logout" : null;

// 8. AUTO-BOOT
window.addEventListener('load', () => {
  bootSystem();
  setTimeout(fetchExchangeRates, 2000);
});

// Export Functions
window.exportVendorsToExcel = function() {
    const vendors = JSON.parse(localStorage.getItem('shopify_vendors') || '[]');
    if (vendors.length === 0) {
        alert('No vendor data to export');
        return;
    }
    
    const exportData = vendors.map(v => ({
        'Vendor ID': v.id,
        'Store Name': v.storeName,
        'Email': v.email,
        'Phone': v.phone,
        'Commission %': v.commission,
        'Status': v.status,
        'Created Date': new Date(v.createdAt).toLocaleDateString()
    }));
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendors");
    XLSX.writeFile(wb, `Vendors_List_${new Date().toISOString().split('T')[0]}.xlsx`);
};

window.checkERPStatus = function() {
  console.table({
    'Bridge URL': SYSTEM.BRIDGE,
    'Products Loaded': MASTER_DB.products.length,
    'Orders Loaded': MASTER_DB.orders.length,
    'Customers Loaded': MASTER_DB.customers.length,
    'Collections Loaded': MASTER_DB.collections.length,
    'Mapping Loaded': MASTER_DB.mapping.length
  });
};